import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";
import GUIset_2Input from "./gui/GUIset_2Input";

const SCS = () => {
	useEffect(() => {
		document.title = "Shortest Common Supersequence (SCS) problem";
	}, []);
	const [guiTxt1, guiTxtChange1] = useState("AGGTAB");
	const [guiTxt2, guiTxtChange2] = useState("GXTXAYB");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "" && guiTxt2 != "") {
			Timer.setTimeBudget(4999);
			Timer.start();
			process(guiTxt1, guiTxt2);
			txt_time = Timer.stop_print();
			//---------
			BuildResult();
			dp = null; //[][]
		}
	};

	var txt_time = "";
	var txt_result = "";
	var txt_result2 = "";
	var dp; //[][]
	var m = 0;
	var n = 0;

	//longestCommonSubsequence
	function process(s1, s2) {
		txt_result = "Length: " + SCS_value(s1, s2);
		txt_result2 = SCS_text(s1, s2);
		console.log(txt_result);
		console.log(txt_result2);
	}

	function SCS_value(s1, s2) {
		m = s1.length;
		n = s2.length;
		dp = T.getMatrix(m + 1, n + 1, 0);
		// console.log("AAAAA " + s1 + "_" + s2 + " *** " + result);
		for (var i = 0; i <= m; i++) {
			for (var j = 0; j <= n; j++) {
				if (i == 0) {
					dp[i][j] = j;
				} //1 is empty, add all from 2
				else if (j == 0) {
					dp[i][j] = i;
				} //2 is empty, add all from 1
				else if (s1.charAt(i - 1) == s2.charAt(j - 1)) {
					dp[i][j] = 1 + dp[i - 1][j - 1]; //same char, add it and go on
				} else {
					dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1]); //to add 1 or 2
				}
			}
		}
		return dp[m][n];
	}

	function SCS_text(s1, s2) {
		//read from dp: https://www.geeksforgeeks.org/print-shortest-common-supersequence/
		//WRONG https://takeuforward.org/data-structure/shortest-common-supersequence-dp-31/
		var output = "";
		let i = m,
			j = n;
		while (i > 0 && j > 0) {
			// If current character in X and Y are same, then current character is part of shortest supersequence
			if (s1[i - 1] == s2[j - 1]) {
				// Put current character in result
				output += s1[i - 1];
				i--;
				j--;
			}
			// If current character in X and Y are different
			else if (dp[i - 1][j] > dp[i][j - 1]) {
				// Put current character of Y in result
				output += s2[j - 1];
				j--;
			} else {
				// Put current character of X in result
				output += s1[i - 1];
				i--;
			}
		}
		// If Y reaches its end, put remaining characters of X in the result string
		while (i > 0) {
			output += s1[i - 1];
			i--;
		}
		// If X reaches its end, put remaining characters of Y in the result string
		while (j > 0) {
			output += s2[j - 1];
			j--;
		}
		return T.strReverse(output);
	}

	function BuildResult() {
		partResultChange(Template.simple4size("key2","Result",txt_result2,"\n"+txt_result,txt_time,28,24,20,18));
	}

	return (
		<GUIset_2Input
		title={"Shortest Common Supersequence (SCS)"}
		desc={
			"Given two strings, return the shortest string that has both strings."
		}
			guiTxtChange1={guiTxtChange1}
			guiTxtChange2={guiTxtChange2}
			buttonClick1={buttonClick1}
			partResult={partResult}
			//------
			label1={"String1"}
			label2={"String2"}
			guiTxt1={guiTxt1}
			guiTxt2={guiTxt2}
			numberOnly1={false}
			numberOnly2={false}
			txtButton={"Calculate"}
		/>
	);
};

export default SCS;


// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";
// import T from "./TheTool";// NOT WORK, old ver


	// const [guiTxt1, guiTxtChange1] = useState("geek");
	// const [guiTxt2, guiTxtChange2] = useState("eke");
	// const [guiTxt1, guiTxtChange1] = useState("brute");
	// const [guiTxt2, guiTxtChange2] = useState("groot");


// function BuildResult() {
// 	// partResultChange(
// 	// 	<div>
// 	// 		<div style={{ whiteSpace: "pre-line", fontSize: 26, paddingRight: 20 }}>
// 	// 			<b>Result</b>
// 	// 		</div>
// 	// 		<div style={{ whiteSpace: "pre-line", fontSize: 24 }}>
// 	// 			{txt_result2}
// 	// 		</div>
// 	// 		<br />
// 	// 		<div
// 	// 			style={{ whiteSpace: "pre-line", fontSize: 20, alignItems: "left" }}
// 	// 		>
// 	// 			{txt_result}
// 	// 		</div>

// 	// 		{txt_time}
// 	// 	</div>
// 	// );
// }

// return (
// 	<div className="todoapp stack-large">
// 		<GUI_Header
// 			title={"Shortest Common Supersequence (SCS)"}
// 			desc={
// 				"Given two strings, return the shortest string that has both strings."
// 			}
// 		/>
// 		<div style={{ marginTop: "3em" }}> </div>
// 		<GUI_InputTextSingle
// 			label={"String 1"}
// 			text1={guiTxt1}
// 			text1Change={guiTxtChange1}
// 			numberOnly={false}
// 			fontSize2={22}
// 			width1={120}
// 			width2={'80%'}
// 		/>
// 		<GUI_InputTextSingle
// 			label={"String 2"}
// 			text1={guiTxt2}
// 			text1Change={guiTxtChange2}
// 			numberOnly={false}
// 			fontSize2={22}
// 			width1={120}
// 			width2={'80%'}
// 		/>
// 		<div style={{ display: "flex", marginLeft: '15%',marginRight: 0 }}>
// 			<button
// 				onClick={() => buttonClick1()}
// 				className="btn btn__primary btn__lg"
// 				style={{ flex: 1, height: 50 }}
// 			>
// 				Calculate
// 			</button>
// 		</div>
// 		<div style={{ marginTop: "3em" }}> </div>
// 		{partResult}
// 		{/* {GetResult()} */}
// 		<GUI_Credit />
// 	</div>
// );